<template>
  <!-- Template remains exactly the same - no changes needed -->
  <head>
    <meta charset="utf-8">
    <title>Government Dashboard</title>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Government workforce monitoring dashboard" name="description">
    <meta content="" name="author">
    <link href="assets/images/favicon.svg" rel="shortcut icon">
    <link id="bootstrap-style" href="assets/css/bootstrap.min.css" rel="stylesheet" type="text/css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css">
    <link id="app-style" href="assets/css/app.min.css" rel="stylesheet" type="text/css">
    <link id="custom-style" href="assets/css/custom.css" rel="stylesheet" type="text/css">
  </head>
  
  <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <Navigation />
      
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">
            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">Dashboard</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Metrics cards -->
            <div class="row">
              <div class="col-md-3">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Total Establishment</p>
                        <h4 class="mb-0">{{ metrics.totalEmployees }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="avatar-sm rounded-circle bg-success mini-stat-icon">
                          <span class="avatar-title rounded-circle bg-success">
                            <i class="bx bx-group font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Employees Added (This Month)</p>
                        <h4 class="mb-0">{{ metrics.employeesAddedThisMonth }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="avatar-sm rounded-circle bg-info mini-stat-icon">
                          <span class="avatar-title rounded-circle bg-info">
                            <i class="bx bx-user-plus font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Absent Without Permission</p>
                        <h4 class="mb-0">{{ metrics.absentWithoutPermission }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="avatar-sm rounded-circle bg-danger mini-stat-icon">
                          <span class="avatar-title rounded-circle bg-danger">
                            <i class="bx bx-user-x font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Absent With Permission</p>
                        <h4 class="mb-0">{{ metrics.absentWithPermission }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="avatar-sm rounded-circle bg-warning mini-stat-icon">
                          <span class="avatar-title rounded-circle bg-warning">
                            <i class="bx bx-user-check font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Charts -->
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-4">
                <div class="card">
                  <div class="card-header bg-transparent border-bottom border-success">
                    <div class="d-sm-flex flex-wrap">
                      <h4 class="card-title text-black text-uppercase">Live Monitoring</h4>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="map" dir="ltr" style="height: 400px"></div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 col-md-4 col-lg-4">
                <div class="card">
                  <div class="card-header bg-transparent border-bottom border-success">
                    <div class="d-sm-flex flex-wrap">
                      <h4 class="card-title text-black text-uppercase">Attendance Summary for This Year</h4>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="AttendanceContainer"></div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-md-5 col-lg-4 px-sm-30px">
                <div class="card member-wedges-card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="d-flex flex-wrap align-items-start">
                        <h5 class="mb-3 me-2 text-black">Employee attendance for Today</h5>
                      </div>
                    </div>
                    <div id="TodayAttendanceContainer"></div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 col-md-4">
                <div class="card">
                  <div class="card-header">
                    <div class="d-flex flex-wrap align-items-start">
                      <h5 class="mb-3 me-2 text-black">Staff Turnover by Department {{ currentMonth }} {{ currentYear }}</h5>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="NewContainer"></div>
                  </div>
                </div>
              </div>
              
              <div class="col-sm-12 col-md-4">
                <div class="card">
                  <div class="card-header">
                    <div class="d-flex flex-wrap align-items-start">
                      <h5 class="mb-3 me-2 text-black">Nature Of Exits</h5>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="ExitChart"></div>
                  </div>
                </div>
              </div>
              
              <div class="col-sm-12 col-md-4">
                <div class="card">
                  <div class="card-header">
                    <div class="d-flex flex-wrap align-items-start">
                      <h5 class="mb-3 me-2 text-black">Nature of Entries</h5>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="EntryChart"></div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div class="card">
                  <div class="card-header">
                    <div class="d-flex flex-wrap align-items-start">
                      <h5 class="mb-3 me-2 text-black">Gender Comparisons</h5>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="GenderContainer"></div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div class="card">
                  <div class="card-header">
                    <div class="d-flex flex-wrap align-items-start">
                      <h5 class="mb-3 me-2 text-black">Distribution of Employees with Disabilities</h5>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="disabilityChart"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                {{ currentYear }} © Government Dashboard
              </div>
              <div class="col-sm-6">
                <div class="text-sm-end d-sm-block"></div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import Navigation from "@/components/Navigation.vue";
import Highcharts from 'highcharts';
import 'highcharts/modules/drilldown';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/accessibility';
import { authUrl, execute } from "@/api";

// ========== ENHANCEMENT 1: Centralized configuration ==========
const CHART_CONFIG = {
  colors: {
    present: '#0caf60',
    absent: '#ff3a6e',
    success: '#0caf60',
    danger: '#ff3a6e',
    warning: '#ffc107',
    info: '#17a2b8',
    male: '#3366cc',
    female: '#dc3912'
  },
  highcharts: {
    lang: {
      thousandsSep: ',',
      decimalPoint: '.'
    }
  }
};

// Initialize Highcharts with global settings
Highcharts.setOptions(CHART_CONFIG.highcharts);

// ========== ENHANCEMENT 2: Helper functions for code reuse ==========
const DashboardUtils = {
  // Safe number formatting
  formatNumber: (num) => {
    return Highcharts.numberFormat(num, 0, '.', ',');
  },

  // Check if element exists
  elementExists: (id) => {
    return document.getElementById(id) !== null;
  },

  // Create API request form data
  createFormData: (functionName, additionalData = {}) => {
    const formData = new FormData();
    formData.append("function", functionName);
    Object.entries(additionalData).forEach(([key, value]) => {
      formData.append(key, value);
    });
    return formData;
  },

  // Validate coordinates
  isValidCoordinate: (lat, lng) => {
    return lat && lng && 
           !isNaN(parseFloat(lat)) && 
           !isNaN(parseFloat(lng)) &&
           parseFloat(lat) >= -90 && parseFloat(lat) <= 90 &&
           parseFloat(lng) >= -180 && parseFloat(lng) <= 180;
  }
};

export default {
  name: "Dashboard",
  components: { Navigation },
  
  data() {
    return {
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().toLocaleString('default', { month: 'short' }),

      metrics: {
        totalEmployees: "0",
        employeesAddedThisMonth: "0",
        absentWithoutPermission: "0",
        absentWithPermission: "0"
      },

      // Data objects remain the same
      attendanceData: null,
      todayAttendanceData: null,
      staffTurnoverData: null,
      natureOfExitData: null,
      natureOfEntryData: null,
      genderComparisonData: null,
      disabilityDistribution: null,

      // ENHANCEMENT 3: Add loading states
      isLoading: {
        metrics: false,
        attendance: false,
        todayAttendance: false,
        turnover: false,
        exits: false,
        entries: false,
        gender: false,
        disability: false,
        map: false
      },

      // ENHANCEMENT 4: Add error states
      errors: {
        metrics: null,
        attendance: null,
        todayAttendance: null,
        turnover: null,
        exits: null,
        entries: null,
        gender: null,
        disability: null,
        map: null
      }
    };
  },

  mounted() {
    this.loadDashboardData();
  },

  methods: {
    // ========== ENHANCEMENT 5: Organized loading with error handling ==========
    async loadDashboardData() {
      try {
        // Load data in parallel for better performance
        await Promise.all([
          this.getEmployeeMetrics(),
          this.getAttendanceSummary(),
          this.getTodayAttendance(),
          this.getStaffTurnover(),
          this.getNatureOfExits(),
          this.getNatureOfEntries(),
          this.getGenderComparison(),
          this.getDisabilityDistribution(),
          this.getEmployeesMap()
        ]);
      } catch (error) {
        console.error('Error loading dashboard data:', error);
      }
    },

    // ========== ENHANCEMENT 6: Improved API call wrapper ==========
    async makeApiCall(functionName, loadingKey = null, errorKey = null) {
      if (loadingKey) this.isLoading[loadingKey] = true;
      if (errorKey) this.errors[errorKey] = null;

      try {
        const formData = DashboardUtils.createFormData(functionName);
        const response = await execute(formData, authUrl);
        
        if (response.data.success) {
          return response.data.data;
        } else {
          const errorMsg = response.data.message || `Failed to load ${functionName}`;
          if (errorKey) this.errors[errorKey] = errorMsg;
          console.error(`API Error (${functionName}):`, errorMsg);
          return null;
        }
      } catch (error) {
        const errorMsg = `Network error loading ${functionName}`;
        if (errorKey) this.errors[errorKey] = errorMsg;
        console.error(`Network Error (${functionName}):`, error);
        return null;
      } finally {
        if (loadingKey) this.isLoading[loadingKey] = false;
      }
    },

    // ========== ENHANCEMENT 7: Refactored metric loading ==========
    async getEmployeeMetrics() {
      const data = await this.makeApiCall('getEmployeeMetrics', 'metrics', 'metrics');
      if (data && data.metrics) {
        this.metrics = data.metrics;
      }
    },

    async getAttendanceSummary() {
      this.attendanceData = await this.makeApiCall('getAttendanceSummary', 'attendance', 'attendance');
      this.renderAttendanceChart();
    },

    async getTodayAttendance() {
      this.todayAttendanceData = await this.makeApiCall('getTodayAttendance', 'todayAttendance', 'todayAttendance');
      this.renderAttendanceChartToday(this.todayAttendanceData);
    },

    async getStaffTurnover() {
      this.staffTurnoverData = await this.makeApiCall('getStaffTurnover', 'turnover', 'turnover');
      if (this.staffTurnoverData) {
        this.renderStaffTurnoverChart(this.staffTurnoverData);
      }
    },

    async getNatureOfExits() {
      this.natureOfExitData = await this.makeApiCall('getNatureOfExits', 'exits', 'exits');
      if (this.natureOfExitData) {
        this.renderNatureOfExitsChart(this.natureOfExitData);
      }
    },

    async getNatureOfEntries() {
      this.natureOfEntryData = await this.makeApiCall('getNatureOfEntries', 'entries', 'entries');
      if (this.natureOfEntryData) {
        this.renderNatureOfEntriesChart(this.natureOfEntryData);
      }
    },

    async getGenderComparison() {
      this.genderComparisonData = await this.makeApiCall('getGenderComparison', 'gender', 'gender');
      if (this.genderComparisonData) {
        this.renderGenderComparisonChart(this.genderComparisonData);
      }
    },

    async getDisabilityDistribution() {
      this.disabilityDistribution = await this.makeApiCall('getDisabilityDistribution', 'disability', 'disability');
      if (this.disabilityDistribution) {
        this.renderDisabilityDistributionChart(this.disabilityDistribution);
      }
    },

    async getEmployeesMap() {
      const data = await this.makeApiCall('getEmployeesMap', 'map', 'map');
      if (data) {
        this.initMap(data.employees || []);
      }
    },

    // ========== ENHANCEMENT 8: Improved map initialization ==========
    initMap(employees = []) {
      if (!DashboardUtils.elementExists('map')) return;

      const defaultCenter = { lat: -1.2691307511790206, lng: 36.79803175971192 };
      
      // Request user location but don't wait for it
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // Optional: Could use user location as center
            console.log('User location:', position.coords);
          },
          (error) => {
            console.log('Geolocation error:', error);
          },
          { enableHighAccuracy: false, timeout: 5000 }
        );
      }

      // Create map
      const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 13,
        center: defaultCenter,
        mapTypeControl: true,
        streetViewControl: false
      });

      // Add markers
      this.addEmployeeMarkers(map, employees);
    },

    addEmployeeMarkers(map, employees) {
      employees.forEach((employee) => {
        if (!DashboardUtils.isValidCoordinate(employee.lat, employee.lng)) {
          console.warn("Invalid coordinates for employee:", employee);
          return;
        }

        const position = {
          lat: parseFloat(employee.lat),
          lng: parseFloat(employee.lng)
        };

        const marker = new google.maps.Marker({
          position: position,
          map: map,
          title: `${employee.firstName} ${employee.lastName}`.trim()
        });

        // Create info window
        const fullName = `${employee.firstName} ${employee.middleName || ''} ${employee.lastName}`.trim();
        const infoWindow = new google.maps.InfoWindow({
          content: `
            <div class="p-2">
              <h6 class="text-capitalize mb-1">${fullName}</h6>
              <p class="mb-0 small">Location: ${position.lat.toFixed(6)}, ${position.lng.toFixed(6)}</p>
            </div>
          `
        });

        // Add hover interactions
        marker.addListener("mouseover", () => infoWindow.open(map, marker));
        marker.addListener("mouseout", () => infoWindow.close());
      });
    },

    // ========== ENHANCEMENT 9: Chart rendering helpers ==========
    renderAttendanceChart() {
      if (!DashboardUtils.elementExists('AttendanceContainer')) return;

      const defaultData = this.getDefaultAttendanceData();
      const { presentData, absentData } = this.processAttendanceData(defaultData);

      Highcharts.chart('AttendanceContainer', {
        chart: { type: 'column' },
        title: { text: null },
        xAxis: {
          type: 'category',
          labels: { rotation: -45, style: { fontSize: '11px' } }
        },
        yAxis: {
          min: 0,
          title: { text: 'Total Days' },
          stackLabels: {
            enabled: true,
            formatter: function() {
              return DashboardUtils.formatNumber(this.total);
            }
          }
        },
        legend: { align: 'center', verticalAlign: 'bottom' },
        tooltip: {
          headerFormat: '<b>Attendance Report for {point.key}</b><br/>',
          pointFormatter: function() {
            const present = this.series.chart.series[0].data[this.index].y;
            const absent = this.series.chart.series[1].data[this.index].y;
            const total = present + absent;
            return `
              <span style="color: ${CHART_CONFIG.colors.present}; font-weight: 600;">Present:</span> 
              ${DashboardUtils.formatNumber(present)}<br/>
              <span style="color: ${CHART_CONFIG.colors.absent}; font-weight: 600;">Absent:</span> 
              ${DashboardUtils.formatNumber(absent)}<br/>
              <span style="font-weight: 600;">Total:</span> 
              ${DashboardUtils.formatNumber(total)}
            `;
          }
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              formatter: function() {
                return DashboardUtils.formatNumber(this.y);
              }
            }
          }
        },
        series: [
          {
            name: 'Present',
            color: CHART_CONFIG.colors.present,
            data: presentData
          },
          {
            name: 'Absent',
            color: CHART_CONFIG.colors.absent,
            data: absentData
          }
        ]
      });
    },

    getDefaultAttendanceData() {
      return {
        present: [
          { name: 'JAN', y: 6200 }, { name: 'FEB', y: 7480 },
          { name: 'MAR', y: 7450 }, { name: 'APR', y: 7400 },
          { name: 'MAY', y: 7350 }, { name: 'JUN', y: 7300 },
          { name: 'JUL', y: 7200 }, { name: 'AUG', y: 7100 },
          { name: 'SEP', y: 6950 }, { name: 'OCT', y: 6700 },
          { name: 'NOV', y: 6400 }, { name: 'DEC', y: 6000 }
        ],
        absent: [
          { name: 'JAN', y: 1820 }, { name: 'FEB', y: 240 },
          { name: 'MAR', y: 270 }, { name: 'APR', y: 320 },
          { name: 'MAY', y: 370 }, { name: 'JUN', y: 420 },
          { name: 'JUL', y: 520 }, { name: 'AUG', y: 620 },
          { name: 'SEP', y: 770 }, { name: 'OCT', y: 1020 },
          { name: 'NOV', y: 1320 }, { name: 'DEC', y: 1720 }
        ]
      };
    },

    processAttendanceData(defaultData) {
      let presentData = [...defaultData.present];
      let absentData = [...defaultData.absent];

      // Use API data if available
      if (this.attendanceData?.chartData?.series) {
        const apiSeries = this.attendanceData.chartData.series;
        if (apiSeries[0]?.data) presentData = apiSeries[0].data;
        if (apiSeries[1]?.data) absentData = apiSeries[1].data;
      }

      return { presentData, absentData };
    },

    // ========== ENHANCEMENT 10: Keep existing methods but add safeguards ==========
    renderAttendanceChartToday(attendanceData) {
      if (!DashboardUtils.elementExists('TodayAttendanceContainer') || !attendanceData) {
        return;
      }

      Highcharts.chart('TodayAttendanceContainer', {
        chart: { type: 'column' },
        title: { text: null },
        subtitle: { text: 'Today\'s attendance by department' },
        xAxis: { type: 'category' },
        yAxis: { title: { text: 'Number of Employees' } },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
              formatter: function() {
                return DashboardUtils.formatNumber(this.y);
              }
            }
          }
        },
        series: attendanceData.chartData?.series || [],
        drilldown: attendanceData.chartData?.drilldown || {}
      });
    },

    renderStaffTurnoverChart(turnoverData) {
      if (!DashboardUtils.elementExists('NewContainer') || !turnoverData) {
        return;
      }

      Highcharts.chart('NewContainer', {
        chart: { type: 'bar' },
        title: { text: null },
        subtitle: { text: turnoverData.chartData?.subtitle || '' },
        xAxis: turnoverData.chartData?.xAxis || { categories: [] },
        yAxis: { min: 0, title: { text: 'Number of Employees' } },
        legend: { enabled: true },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              formatter: function() {
                return DashboardUtils.formatNumber(this.y);
              }
            }
          }
        },
        series: turnoverData.chartData?.series || []
      });
    },

    renderNatureOfExitsChart(exitsData) {
      if (!DashboardUtils.elementExists('ExitChart') || !exitsData) {
        return;
      }

      const seriesData = exitsData.chartData?.series?.[0]?.data || [];
      
      Highcharts.chart('ExitChart', {
        chart: { type: 'pie' },
        title: { text: 'Nature of Exits' },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            }
          }
        },
        series: [{
          name: 'Exits',
          colorByPoint: true,
          data: seriesData
        }]
      });
    },

    renderNatureOfEntriesChart(entriesData) {
      if (!DashboardUtils.elementExists('EntryChart') || !entriesData) {
        return;
      }

      const seriesData = entriesData.chartData?.series?.[0]?.data || [];
      
      Highcharts.chart('EntryChart', {
        chart: { type: 'pie' },
        title: { text: 'Nature of New Hires' },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            }
          }
        },
        series: [{
          name: 'New Hires',
          colorByPoint: true,
          data: seriesData
        }]
      });
    },

    renderGenderComparisonChart(genderData) {
      if (!DashboardUtils.elementExists('GenderContainer') || !genderData) {
        return;
      }

      Highcharts.chart('GenderContainer', {
        chart: { type: 'pie' },
        title: { text: null },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            }
          }
        },
        series: genderData.chartData?.series || []
      });
    },

    renderDisabilityDistributionChart(disabilityData) {
      if (!DashboardUtils.elementExists('disabilityChart') || !disabilityData) {
        return;
      }

      const seriesData = disabilityData.chartData?.series?.[0]?.data || [];
      
      Highcharts.chart('disabilityChart', {
        chart: { type: 'pie' },
        title: { text: null },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y} ({point.percentage:.1f}%)'
            }
          }
        },
        series: [{
          name: 'Disability Distribution',
          colorByPoint: true,
          data: seriesData
        }]
      });
    }
  }
};
</script>

<style>
/* ========== ENHANCEMENT 11: Add minimal CSS improvements ========== */

/* Add loading indicator */
.loading {
  opacity: 0.7;
  pointer-events: none;
}

/* Better focus for accessibility */
.card:focus-within {
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}

/* Responsive improvements */
@media (max-width: 768px) {
  .col-md-3 {
    margin-bottom: 1rem;
  }
}

/* Print styles */
@media print {
  .no-print {
    display: none !important;
  }
}
</style>